import { useCustom } from '@refinedev/core';
import { Spin } from 'antd';
import { ShieldCheck } from 'lucide-react';
import { useMemo, type FC } from 'react';

import PlanGatesGrid from '@/components/ops/PlanGatesGrid';

export interface PlanGate {
  featureKey: string;
  label: string;
  category: string;
  plans: Record<string, boolean>;
}

const PLANS = ['free', 'solo', 'starter', 'team', 'enterprise'] as const;

const PlanGatesPage: FC = () => {
  const { data, isLoading, refetch } = useCustom<{ data: { items: PlanGate[] } }>({
    url: '/api/v1/admin/plan-gates',
    method: 'get',
  });

  const gates = data?.data?.data?.items ?? [];

  const grouped = useMemo(() => {
    const map = new Map<string, PlanGate[]>();
    for (const gate of gates) {
      const cat = gate.category || 'Autre';
      if (!map.has(cat)) map.set(cat, []);
      map.get(cat)!.push(gate);
    }
    return map;
  }, [gates]);

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <GradientHeader />
      <PlanGatesGrid grouped={grouped} plans={PLANS} onRefetch={refetch} />
    </div>
  );
};

const GradientHeader: FC = () => (
  <div className="fc-gradient-header rounded-2xl p-6 text-white">
    <div className="flex items-center gap-3">
      <ShieldCheck className="h-6 w-6" />
      <div>
        <h1 className="text-xl font-bold">Plan Gates</h1>
        <p className="mt-1 text-sm text-blue-100">
          Matrice des features par plan d'abonnement
        </p>
      </div>
    </div>
  </div>
);

export default PlanGatesPage;
